import * as React from "react";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import DataTools from "../DataTools/DataTools";
import "../SidebarMenu/categoryStyle.css";
import { Link } from "react-router-dom";

// const boxStyle = {
//   width: "250px",
//   height: "207px",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   flexWrap: "wrap",
//   border: "1px solid black",
// };

// const imageStyle = {
//   width: "100%",
//   maxWidth: "240px",
//   maxHeight: "200px",
// };

// const titleStyle = {
//   width: "100%",
//   maxWidth: "240px",
//   textAlign: "center",
// };

export default function DownHoleTool() {
  const itemsPerPage = 9; // Number of items to display per page
  const [page, setPage] = React.useState(1);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedTools = DataTools.slice(startIndex, endIndex);

  return (
    <div style={{ width: "100%" }}>
      <Box className="main-box">
        {displayedTools.map((tool, index) => (
          <Box key={index}>
            <Link
              to={`/tool/details/${tool.id}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Box className="box">
                <Box>
                  <img
                    src={tool.image}
                    alt={`Tool ${tool.id}`}
                    className="image"
                  />{" "}
                  {/* Use the image directly or from the array */}
                </Box>
              </Box>
              <Box className="title">
                <p>{tool.title}</p>
              </Box>
            </Link>
          </Box>
        ))}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <Pagination
          count={Math.ceil(DataTools.length / itemsPerPage)} // Calculate total number of pages
          page={page}
          onChange={handleChange}
          color="primary"
        />
      </Box>
    </div>
  );
}
